import bigCar from '@assets/images/parking-search/parking-car.webp';

interface Props {
  plannedReturnDate: string;
}

export default function MaintenancePage({ plannedReturnDate }: Props) {
  return (
    <div className="bg-web-orange flex min-h-dvh w-full items-center justify-center p-6">
      <img
        src={bigCar}
        alt=""
        aria-hidden="true"
        className="md absolute top-5 -left-40 rotate-220 md:top-20 md:-left-60"
      />
      <div className="flex max-w-xl flex-col items-center gap-8 text-center">
        <section className="flex flex-col items-center gap-2">
          <h1 className="text-brand text-2xl font-semibold">Serwis chwilowo niedostępny</h1>
          <p className="text-base font-light text-balance">
            Przepraszamy. Trwają prace modernizacyjne. Planowany termin uruchomienia serwisu: {plannedReturnDate}.
          </p>
        </section>
        <section className="flex flex-col items-center gap-2">
          <h2 className="text-brand text-2xl font-semibold">Service temporarily unavailable</h2>
          <p className="text-base font-light text-balance">
            We apologize. Modernization work is underway. Planned service launch at: {plannedReturnDate}.
          </p>
        </section>
      </div>
    </div>
  );
}
